import { render } from "./SignDone.vue?vue&type=template&id=05e2341a&scoped=true&ts=true"
import script from "./SignDone.vue?vue&type=script&lang=ts"
export * from "./SignDone.vue?vue&type=script&lang=ts"

import "./SignDone.vue?vue&type=style&index=0&id=05e2341a&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e2341a"]])

export default __exports__